import * as React from "react";

import { ModellComponent } from "./ModellComponent";
import { blurInner, checkBlur, setCurrentFocusedField } from "./components";

import { ILoaderProps, IModelHandler } from "../domene"

import Models = Gf.Web.Models;

export abstract class EntitetModellComponent<TFeltType, TModel extends Models.EntitetModell<TFeltType>>
    extends ModellComponent<TModel> implements IModelHandler<TFeltType> {

    protected getHandler(): IModelHandler<TFeltType> {
        return this;
    }

    protected constructor(
        props: ILoaderProps,
        private readonly path: string) {
        super(props);
    }

    getModelPath() {
        return `/${this.path}/Hent/${this.getId()}`;
    }

    formError(error: Models.ApiError, feltType: TFeltType) {
        this.setError(`${feltType}`, error.Message);
    }

    onBlur(
        felt: Models.FeltMedVerdi<TFeltType> | undefined,
        entitetType: Gf.Dom.Type.EntitetType | undefined,
        feltType: TFeltType,
        gammelVerdi: any,
        nyVerdi: any,
        focused: boolean,
        target: any): void {

        if(focused) {
            checkBlur();
        } else {
            blurInner(entitetType, this.getHandler(), this.getId(), feltType, gammelVerdi, nyVerdi);
        }
        if (!!felt && !!target) {
            felt.Verdi = nyVerdi;
            target.value = nyVerdi;
        }
    }

    onFocus(
        entitetType: Gf.Dom.Type.EntitetType | undefined,
        feltType: TFeltType,
        gammelVerdi: any,
        target: any): void {

        checkBlur();

        setCurrentFocusedField({
            onBlur: () => {
                const nyVerdi = target.value;
                blurInner(entitetType, this.getHandler(), this.getId(), feltType, gammelVerdi, nyVerdi);
            }
        });
    }

    onChange(
        felt: Models.FeltMedVerdi<TFeltType> | undefined,
        feltType: TFeltType,
        gammelVerdi: any,
        target: any): void {

        //console.log(gammelVerdi + " => " + target.value);
        if (felt) {
            felt.Verdi = target.value;
        }
    }

    /**
     * Override this to provide client actions
     * @param handling
     */
    clientAction(handling: Models.HandlingType) {
        return false;
    }
}


// WEBPACK FOOTER //
// ./Scripts/React/Component/EntitetModellComponent.tsx